import React from "react";
import get from "lodash.get";
const EventImageBox = (props: any) => {
  const uri = get(props, "uri", null);
  const p = get(props, "public", null);
  const official = get(props, "official", null);
  if (uri) {
    return (
      <img
        src={uri}
        style={{
          display: "block",
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          height: "auto",
          maxHeight: "100vh",
          objectFit: "contain",
          alignSelf: "center",
        }}
      ></img>
    );
  }
  return null;
};

export default EventImageBox;
